import { render } from "./CreateTicket.vue?vue&type=template&id=0edc1f64"
import script from "./CreateTicket.vue?vue&type=script&lang=ts"
export * from "./CreateTicket.vue?vue&type=script&lang=ts"

import "./CreateTicket.vue?vue&type=style&index=0&id=0edc1f64&lang=css"
script.render = render

export default script